/* global filter_obj, history */
jQuery(document).ready(function($) {
    // Run on load
    setDescHeight();

    // Run on resize (debounced)
    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setDescHeight, 200);
    });

    if ($('.ccs-dropdown').length > 0) {
        $('.ccs-dropdown .ccs-filter-title').click(function(e) {
            e.preventDefault();

            const currentDropdown = $(this).closest('.ccs-dropdown');
            const currentMenu = $(this).next('.ccs-filter-menu');

            // Close all other dropdowns
            $('.ccs-dropdown').not(currentDropdown).removeClass('is-active').find('.ccs-filter-menu').slideUp();

            // Toggle current dropdown
            currentDropdown.toggleClass('is-active');
            currentMenu.stop(true, true).slideToggle();
        });
    }

    // Click outside â†’ close all
    $(document).click(function(e) {
        if (!$(e.target).closest('.ccs-dropdown').length && !$(e.target).closest('.lg-dropdown').length) {
            $('.ccs-dropdown').removeClass('is-active').find('.ccs-filter-menu').slideUp();
            $('.lg-dropdown').removeClass('active').find('.lg-filter-menu').slideUp();
        }
    });

    /************* Post Filter - START *****************/
    $('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();
        let asset_type = [];
        let post_tag = [];
        let resource_types = [];
        let use_cases = [];

        $('.lg-filter-selected-list').empty();

        // Handle Event asset type filters
        $('.post-ajax-filter form.listing-filter-form input[name="asset_type"]:checked').each(function() {
            asset_type.push($(this).val());
            const asset_type_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append(
                '<span class="lg-selected asset_type-selected" data-slug="asset_type_' + $(this).val() + '"><em class="close-icon"></em>' + asset_type_label + '</span>',
            );
        });

        // Handle Event post tag filters
        $('.post-ajax-filter form.listing-filter-form input[name="post_tag"]:checked').each(function() {
            post_tag.push($(this).val());
            const post_tag_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append(
                '<span class="lg-selected post_tag-selected" data-slug="post_tag_' + $(this).val() + '"><em class="close-icon"></em>' + post_tag_label + '</span>',
            );
        });

        // Handle Event resource types filters
        $('.post-ajax-filter form.listing-filter-form input[name="resource_types"]:checked').each(function() {
            resource_types.push($(this).val());
            const resource_types_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append(
                '<span class="lg-selected resource_types-selected" data-slug="resource_types_' + $(this).val() + '"><em class="close-icon"></em>' + resource_types_label + '</span>',
            );
        });

        // Handle Event use cases filters
        $('.post-ajax-filter form.listing-filter-form input[name="use_cases"]:checked').each(function() {
            use_cases.push($(this).val());
            const use_cases_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append(
                '<span class="lg-selected use_cases-selected" data-slug="use_cases_' + $(this).val() + '"><em class="close-icon"></em>' + use_cases_label + '</span>',
            );
        });

        const pager = $('.post-ajax-filter form.listing-filter-form #pager').val();
        const posts_per_page = $('.post-ajax-filter form.listing-filter-form input[name="posts_per_page"]').val();
        const search_text = $('.post-ajax-filter form.listing-filter-form input[id="lgSearch"]').val();
        const select_post_type = $('.post-ajax-filter form.listing-filter-form input[name="select_post_type"]').val();
        const lg_select_asset_type = $('.post-ajax-filter form.listing-filter-form input[name="lg_asset_type_select"]').val();
        const lg_post_tag_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_post_tag_select"]').val();
        const lg_resource_types_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_resource_types_select"]').val();
        const lg_use_cases_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_use_cases_select"]').val();
        const lg_display_post_date = $('.post-ajax-filter form.listing-filter-form input[name="lg_display_post_date"]').val();
        const sort_value = $('.post-ajax-filter form.listing-filter-form .filter-order').val();

        // Get selected filters as comma-separated strings
        asset_type = $('.post-ajax-filter form.listing-filter-form input[name="asset_type"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        post_tag = $('.post-ajax-filter form.listing-filter-form input[name="post_tag"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        resource_types = $('.post-ajax-filter form.listing-filter-form input[name="resource_types"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        use_cases = $('.post-ajax-filter form.listing-filter-form input[name="use_cases"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        modify_post_filter_url(pager, search_text, sort_value, asset_type, post_tag, resource_types, use_cases);

        post_filter_data(pager, posts_per_page, search_text, sort_value, asset_type, lg_select_asset_type, post_tag, lg_post_tag_select, resource_types, lg_resource_types_select, use_cases, lg_use_cases_select, select_post_type, lg_display_post_date);

    });

    // Filter form submission
    $(document).on('change keydown', '.post-ajax-filter form.listing-filter-form .search-text', function(e) {
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
    });

    $(document).on('change', '.post-ajax-filter form.listing-filter-form  .icon-search', function(e) {
        e.preventDefault();
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    });

    $(document).on('click', '.post-ajax-filter form.listing-filter-form .lg-filter-selected-list .lg-selected', function() {
        const fid = $(this).data('slug');
        $('#' + fid).prop('checked', false);
        $(this).remove();
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
        $('.post-ajax-filter form.listing-filter-form ').submit();

    });

    // Category filter
    $('.post-ajax-filter form.listing-filter-form .cat-filter, .post-ajax-filter form.listing-filter-form .filter-order').change(function() {
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    });

    // Pagination next link
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.next', function(event) {
        event.preventDefault();
        const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
        const max_pages = $('.post-ajax-filter form.listing-filter-form input[name="max_pages"]').val();
        if (+pager <= +max_pages) {
            $('.post-ajax-filter form.listing-filter-form #pager').val(+pager + 1);
            $('.post-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Pagination prev link
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.prev', function(event) {
        event.preventDefault();
        const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
        if (+pager >= 1) {
            $('.post-ajax-filter form.listing-filter-form #pager').val(+pager - 1);
            $('.post-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Reset Filter
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .filter-reset', function(e) {
        e.preventDefault();

        // Uncheck all checkboxes
        $('.post-ajax-filter form.listing-filter-form input[type="checkbox"]').prop('checked', false);

        // Clear text fields (like search)
        $('.post-ajax-filter form.listing-filter-form input[type="text"], .post-ajax-filter form.listing-filter-form input[type="search"]').val('');

        // Reset selects (like sort dropdowns)
        $('.post-ajax-filter form.listing-filter-form select').prop('selectedIndex', 0);

        // Clear selected filter tags
        $('.lg-filter-selected-list').empty();

        // Reset pagination
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);

        // Submit the form to refresh results
        $('.post-ajax-filter form.listing-filter-form').submit();

        // Optional: Update the URL (clear all query params)
        const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);
    });

    /**
	 * Post filter data function.
	 *
	 * This function sends an AJAX request to fetch the post list based on the filters selected.
	 *
	 * @param {string} pager - The current page number.
	 * @param {string} posts_per_page - The number of posts to display on each page.
	 * @param {string} search_text - The search text entered by the user.
	 * @param {string} sort_value - The selected sort order.
	 * @param {string} asset_type - The selected asset type filter.
	 * @param {string} lg_select_asset_type - The selected asset type filter.
	 * @param {string} post_tag - The selected post tag filter.
	 * @param {string} lg_post_tag_select - The selected post tag filter.
	 * @param {string} resource_types - The selected resource types filter.
	 * @param {string} lg_resource_types_select - The selected resource types filter.
	 * @param {string} use_cases - The selected use cases filter.
	 * @param {string} lg_use_cases_select - The selected use cases filter.
	 * @param {string} select_post_type - The selected post type filter.
	 * @param {string} lg_display_post_date - The selected post date display option.
	 */
    function post_filter_data(pager, posts_per_page, search_text, sort_value, asset_type, lg_select_asset_type, post_tag, lg_post_tag_select, resource_types, lg_resource_types_select, use_cases, lg_use_cases_select, select_post_type, lg_display_post_date) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: typeof filter_obj !== 'undefined' ? filter_obj.ajax_url : '/wp-admin/admin-ajax.php',
            data: {
                action: select_post_type === 'documentation'
                    ? 'fetch_document_list'
                    : (select_post_type === 'release-note' || select_post_type === 'release-notes')
                        ? 'fetch_release_note_list'
                        : 'fetch_post_list',
                pager: pager,
                posts_per_page: posts_per_page,
                select_post_type: select_post_type,
                search_text: search_text,
                sort_value: sort_value,
                asset_type: asset_type,
                lg_select_asset_type: lg_select_asset_type,
                post_tag: post_tag,
                lg_post_tag_select: lg_post_tag_select,
                resource_types: resource_types,
                lg_resource_types_select: lg_resource_types_select,
                use_cases: use_cases,
                lg_use_cases_select: lg_use_cases_select,
                lg_display_post_date: lg_display_post_date,
                lg_sticky_posts: $('.post-ajax-filter form.listing-filter-form input[name="lg_sticky_posts"]').val(),
            },
            beforeSend: function() {
                const $form = $('.post-ajax-filter form.listing-filter-form');
                const $lgGridArea = $form.find('.lg-grid-area');

                // Set current height inline
                $lgGridArea.css('height', $lgGridArea.outerHeight() + 'px');

                $form.find('.filter-load-more').show();
                $form.find('.pagination').hide();
                $form.find('.lg-grid-main-row').hide();
            },
            success: function(response) {
                const $form = $('.post-ajax-filter form.listing-filter-form');
                $form.find('.filter-load-more').hide();
                $form.find('.lg-grid-main-row').html(response.data).fadeIn();
                $form.find('.pagination').html(response.pagination).show();
                const $lgGridArea = $form.find('.lg-grid-area');

                // Set current height inline
                $lgGridArea.css('height', 'auto');
                if (response.total_pages) {
                    $form.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $form.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $form.find('.showing-result').text(response.showing);
                }

                // Optional: Smooth scroll to top of results
                $('html, body').animate({
                    scrollTop: $('.post-ajax-filter').offset().top - 60,
                }, 800);

                setDescHeight();
            },
            error: function(xhr, status, error) {
                // console.error('AJAX Error:', status, error);
                // console.log(xhr.responseText);
            },
        });
    }

    /**
	 * Modifies the current page URL with the provided filter parameters
	 * and updates the browser URL without refreshing the page.
	 *
	 * @param {string} pager - The current page number.
	 * @param {string} search_text - The search text (if any).
	 * @param {string} sort_value - The sort order value (if any).
	 * @param {string} asset_type - The selected asset type filter value (if any).
	 * @param {string} post_tag - The selected post tag filter value (if any).
	 * @param {string} resource_types - The selected resource type filter value (if any).
	 * @param {string} use_cases - The selected use case filter value (if any).
	 */
    function modify_post_filter_url(pager, search_text, sort_value, asset_type, post_tag, resource_types, use_cases) {

        let query_string = '';
        const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        const select_post_type = $('.post-ajax-filter form.listing-filter-form input[name="select_post_type"]').val();
        query_string += 'pager=' + pager;

        if (asset_type !== '' && typeof asset_type !== 'undefined') {
            query_string += '&asset_type=' + asset_type;
        }
        if (post_tag !== '' && typeof post_tag !== 'undefined') {
            query_string += '&post_tag=' + post_tag;
        }

        if (resource_types !== '' && typeof resource_types !== 'undefined') {
            query_string += '&resource_types=' + resource_types;
        }

        if (use_cases !== '' && typeof use_cases !== 'undefined') {
            query_string += '&use_cases=' + use_cases;
        }

        if ('documentation' === select_post_type) {
            if (search_text !== '' && typeof search_text !== 'undefined') {
                query_string += '&s=' + search_text;
            }
        } else {
            if (search_text !== '' && typeof search_text !== 'undefined') {
                query_string += '&search_text=' + search_text;
            }
        }

        if (sort_value !== '' && typeof sort_value !== 'undefined') {
            query_string += '&filter_order=' + sort_value;
        }

        // Determine if a separator is needed
        const separator = current_page_url.includes('?') ? '&' : '?';
        const updated_url = current_page_url + '' + separator + query_string;

        // Update the browser URL without refreshing the page
        history.pushState(null, null, updated_url);
    }
    /************* Post Filter - END *****************/

    /************* Course Filter - START *****************/
    $('.course-ajax-filter form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();
        let course_collection = [];
        let course_competencie = [];
        let course_countrie = [];
        let course_use_case = [];
        let course_language = [];
        let course_duration = [];

        $('.ccs-filter-selected-list').empty();

        // Handle Event course collection filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_collection"]:checked').each(function() {
            course_collection.push($(this).val());
            const course_collection_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_collection-selected" data-slug="course_collection_' + $(this).val() + '"><em class="close-icon"></em>' + course_collection_label + '</span>',
            );
        });

        // Handle Event course competencies filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_competencie"]:checked').each(function() {
            course_competencie.push($(this).val());
            const course_competencie_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_competencie-selected" data-slug="course_competencie_' + $(this).val() + '"><em class="close-icon"></em>' + course_competencie_label + '</span>',
            );
        });

        // Handle Event course countries filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_countrie"]:checked').each(function() {
            course_countrie.push($(this).val());
            const course_countrie_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_countrie-selected" data-slug="course_countrie_' + $(this).val() + '"><em class="close-icon"></em>' + course_countrie_label + '</span>',
            );
        });

        // Handle Event course use cases filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_use_case"]:checked').each(function() {
            course_use_case.push($(this).val());
            const course_use_case_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_use_case-selected" data-slug="course_use_case_' + $(this).val() + '"><em class="close-icon"></em>' + course_use_case_label + '</span>',
            );
        });

        // Handle Event course duration cases filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_duration"]:checked').each(function() {
            course_duration.push($(this).val());
            const course_duration_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label

            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_duration-selected" data-slug="' + $(this).attr('id') + '"><em class="close-icon"></em>' + course_duration_label + '</span>',
            );
        });

        // Handle Event course languages filters
        $('.course-ajax-filter form.listing-filter-form input[name="course_language"]:checked').each(function() {
            course_language.push($(this).val());
            const course_language_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.ccs-filter-selected-list').append(
                '<span class="ccs-selected course_language-selected" data-slug="course_language_' + $(this).val() + '"><em class="close-icon"></em>' + course_language_label + '</span>',
            );
        });

        const pager = $('.course-ajax-filter form.listing-filter-form #pager').val();
        const posts_per_page = $('.course-ajax-filter form.listing-filter-form input[name="posts_per_page"]').val();
        const search_text = $('.course-ajax-filter form.listing-filter-form input[name="search_text"]').val();
        const sort_value = $('.course-ajax-filter form.listing-filter-form .filter-order').val();

        // Get selected filters as comma-separated strings
        course_collection = $('.course-ajax-filter form.listing-filter-form input[name="course_collection"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        course_competencie = $('.course-ajax-filter form.listing-filter-form input[name="course_competencie"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        course_countrie = $('.course-ajax-filter form.listing-filter-form input[name="course_countrie"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        course_use_case = $('.course-ajax-filter form.listing-filter-form input[name="course_use_case"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        course_duration = $('.course-ajax-filter form.listing-filter-form input[name="course_duration"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        course_language = $('.course-ajax-filter form.listing-filter-form input[name="course_language"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        modify_course_filter_url(pager, search_text, sort_value, course_collection, course_competencie, course_countrie, course_use_case, course_language, course_duration);

        course_filter_data(pager, posts_per_page, search_text, sort_value, course_collection, course_competencie, course_countrie, course_use_case, course_language, course_duration);

    });
    // Filter form submission
    $(document).on('change keydown', '.course-ajax-filter form.listing-filter-form .search-text', function(e) {
        $('.course-ajax-filter form.listing-filter-form #pager').val(1);
    });

    $(document).on('change', '.course-ajax-filter form.listing-filter-form  .icon-search', function(e) {
        e.preventDefault();
        $('.course-ajax-filter form.listing-filter-form #pager').val(1);
        $('.course-ajax-filter form.listing-filter-form').submit();
    });

    $(document).on('click', '.course-ajax-filter form.listing-filter-form .ccs-filter-selected-list .ccs-selected', function() {
        const fid = $(this).data('slug');
        $('#' + fid).prop('checked', false);
        $(this).remove();
        $('.course-ajax-filter form.listing-filter-form #pager').val(1);
        $('.course-ajax-filter form.listing-filter-form ').submit();
    });

    // Category filter
    $('.course-ajax-filter form.listing-filter-form .cat-filter, .course-ajax-filter form.listing-filter-form .filter-order').change(function() {
        $('.course-ajax-filter form.listing-filter-form #pager').val(1);
        $('.course-ajax-filter form.listing-filter-form').submit();
    });

    // Pagination next link
    $(document).on('click', '.course-ajax-filter form.listing-filter-form .pagination a.next', function(event) {
        event.preventDefault();
        const pager = $('.course-ajax-filter form.listing-filter-form input[name="pager"]').val();
        const max_pages = $('.course-ajax-filter form.listing-filter-form input[name="max_pages"]').val();
        if (+pager <= +max_pages) {
            $('.course-ajax-filter form.listing-filter-form #pager').val(+pager + 1);
            $('.course-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Pagination prev link
    $(document).on('click', '.course-ajax-filter form.listing-filter-form .pagination a.prev', function(event) {
        event.preventDefault();
        const pager = $('.course-ajax-filter form.listing-filter-form input[name="pager"]').val();
        if (+pager >= 1) {
            $('.course-ajax-filter form.listing-filter-form #pager').val(+pager - 1);
            $('.course-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Reset Filter
    $(document).on('click', '.course-ajax-filter form.listing-filter-form .filter-reset', function(e) {
        e.preventDefault();

        // Uncheck all checkboxes
        $('.course-ajax-filter form.listing-filter-form input[type="checkbox"]').prop('checked', false);

        // Clear text fields (like search)
        $('.course-ajax-filter form.listing-filter-form input[type="text"], .course-ajax-filter form.listing-filter-form input[type="search"]').val('');

        // Reset selects (like sort dropdowns)
        $('.course-ajax-filter form.listing-filter-form select').prop('selectedIndex', 0);

        // Clear selected filter tags
        $('.lg-filter-selected-list').empty();

        // Reset pagination
        $('.course-ajax-filter form.listing-filter-form #pager').val(1);

        // Submit the form to refresh results
        $('.course-ajax-filter form.listing-filter-form').submit();

        // Optional: Update the URL (clear all query params)
        const current_page_url = $('.course-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);
    });

    /**
	 * Send an AJAX request to fetch the course list based on the filters selected.
	 *
	 * @param {number} pager - The current page number.
	 * @param {number} posts_per_page - The number of posts to display on each page.
	 * @param {string} search_text - The search text entered by the user.
	 * @param {string} sort_value - The selected sort order.
	 * @param {string} course_collection - The selected course collection filter.
	 * @param {string} course_competencie - The selected course competencie filter.
	 * @param {string} course_countrie - The selected course countrie filter.
	 * @param {string} course_use_case - The selected course use case filter.
	 * @param {string} course_language - The selected course language filter.
	 * @param {string} course_duration - The selected course duration filter.
	 */
    function course_filter_data(pager, posts_per_page, search_text, sort_value, course_collection, course_competencie, course_countrie, course_use_case, course_language, course_duration) {
        const catalog_order = $('.course-ajax-filter form.listing-filter-form input[name="catalog_order"]').val();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: typeof filter_obj !== 'undefined' ? filter_obj.ajax_url : '/wp-admin/admin-ajax.php',
            data: {
                action: 'fetch_course_list',
                pager: pager,
                posts_per_page: posts_per_page,
                search_text: search_text,
                sort_value: sort_value,
                course_collection: course_collection,
                course_competencie: course_competencie,
                course_countrie: course_countrie,
                course_use_case: course_use_case,
                course_language: course_language,
                course_duration: course_duration,
                catalog_order: catalog_order,
            },
            beforeSend: function() {
                const $form = $('.course-ajax-filter form.listing-filter-form');
                $form.find('.filter-load-more').show();
                $form.find('.pagination').hide();
                $form.find('.ccs-grid-main-row').hide();
            },
            success: function(response) {
                const $form = $('.course-ajax-filter form.listing-filter-form');
                $form.find('.filter-load-more').hide();
                $form.find('.ccs-grid-main-row').html(response.data).fadeIn();
                $form.find('.pagination').html(response.pagination).show();

                if (response.total_pages) {
                    $form.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $form.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $form.find('.showing-result').text(response.showing);
                }

                // Optional: Smooth scroll to top of results
                $('html, body').animate({
                    scrollTop: $('.course-ajax-filter').offset().top - 60,
                }, 800);
            },
            error: function(xhr, status, error) {
                // console.error('AJAX Error:', status, error);
                // console.log(xhr.responseText);
            },
        });
    }
    /**
	 * Modifies the current page URL with the provided course filter parameters
	 * and updates the browser URL without refreshing the page.
	 *
	 * @param {number} pager - The current page number.
	 * @param {string} search_text - The search text (if any).
	 * @param {string} sort_value - The sort order value (if any).
	 * @param {string} course_collection - The selected course collection filter value (if any).
	 * @param {string} course_competencie - The selected course competencie filter value (if any).
	 * @param {string} course_countrie - The selected course countrie filter value (if any).
	 * @param {string} course_use_case - The selected course use case filter value (if any).
	 * @param {string} course_language - The selected course language filter value (if any).
	 * @param {string} course_duration - The selected course duration filter value (if any).
	 */
    function modify_course_filter_url(pager, search_text, sort_value, course_collection, course_competencie, course_countrie, course_use_case, course_language, course_duration) {

        let query_string = '';
        const current_page_url = $('.course-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        query_string += 'pager=' + pager;

        if (course_collection !== '' && typeof course_collection !== 'undefined') {
            query_string += '&course_collection=' + course_collection;
        }

        if (course_competencie !== '' && typeof course_competencie !== 'undefined') {
            query_string += '&course_competencie=' + course_competencie;
        }

        if (course_countrie !== '' && typeof course_countrie !== 'undefined') {
            query_string += '&course_countrie=' + course_countrie;
        }

        if (course_use_case !== '' && typeof course_use_case !== 'undefined') {
            query_string += '&course_use_case=' + course_use_case;
        }

        if (course_language !== '' && typeof course_language !== 'undefined') {
            query_string += '&course_language=' + course_language;
        }

        if (course_duration !== '' && typeof course_duration !== 'undefined') {
            query_string += '&course_duration=' + course_duration;
        }

        if (search_text !== '' && typeof search_text !== 'undefined') {
            query_string += '&search_text=' + search_text;
        }

        if (sort_value !== '' && typeof sort_value !== 'undefined') {
            query_string += '&filter_order=' + sort_value;
        }

        // Determine if a separator is needed
        const separator = current_page_url.includes('?') ? '&' : '?';
        const updated_url = current_page_url + '' + separator + query_string;

        // Update the browser URL without refreshing the page
        history.pushState(null, null, updated_url);
    }
    /************* Course Filter - END *****************/

    function setDescHeight() {
        $('.lg-grid-item').each(function() {
            const item = $(this);
            const desc = item.find('.desc');

            if (desc.length) {
                // Save current inline styles
                const prevStyles = {
                    height: desc[0].style.height,
                    opacity: desc[0].style.opacity,
                    visibility: desc[0].style.visibility,
                };

                // Temporarily reveal for measurement
                desc.css({
                    height: 'auto',
                    opacity: 0,
                    visibility: 'hidden',
                    display: 'block',
                });

                const descHeight = desc.outerHeight();

                // Restore styles
                desc.css(prevStyles);

                // Set CSS variable
                this.style.setProperty('--desc-height', descHeight + 'px');
            }
        });
    }

    /************* Filterable Card Filter - START *****************/
    let isLoading = false;

    function updateFcgSelectedPills($section) {
        const $list = $section.find('.lg-filter-selected-list');
        $list.empty();

        $section.find('input[name="industry"]:checked').each(function() {
            const label = $(this).closest('li').find('label').data('label') || $(this).closest('li').find('label').text();
            $list.append(
                '<span class="lg-selected industry-selected" data-slug="industry_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );
        });

        $section.find('input[name="use_cases"]:checked').each(function() {
            const label = $(this).closest('li').find('label').data('label') || $(this).closest('li').find('label').text();
            $list.append(
                '<span class="lg-selected use_cases-selected" data-slug="use_cases_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );
        });
    }

    // RESET + SEARCH
    function resetAndSearchFcg($section) {
        updateFcgSelectedPills($section);
        $section.find('#pager').val(1);
        $section.find('.fcg-row').html('');

        loadPosts($section, 1);
    }

    // CHECKBOX FILTER CHANGE
    $(document).on('change', '.filterable-card-grid-section:not(.case-study-listing-grid-section) .cat-filter', function() {
        const $section = $(this).closest('.filterable-card-grid-section');
        resetAndSearchFcg($section);
    });

    // CLICK ON SELECTED PILL REMOVE
    $(document).on('click', '.filterable-card-grid-section:not(.case-study-listing-grid-section) .lg-filter-selected-list .lg-selected', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.filterable-card-grid-section');
        const fid = $(this).data('slug');
        $section.find('#' + fid).prop('checked', false);
        $('#' + fid).prop('checked', false);
        $(this).remove();
        resetAndSearchFcg($section);
    });

    // RESET FILTER
    $(document).on('click', '.filterable-card-grid-section:not(.case-study-listing-grid-section) .filter-reset, .filterable-card-grid-section:not(.case-study-listing-grid-section) .reset-filter', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.filterable-card-grid-section');

        $section.find('input[type="checkbox"]').prop('checked', false);
        $section.find('.search-text').val('');
        $section.find('.lg-filter-selected-list').empty();
        $section.find('.filter-order').val('');

        resetAndSearchFcg($section);
    });

    // ORDER FILTER CHANGE
    $(document).on('change', '.filterable-card-grid-section:not(.case-study-listing-grid-section) .filter-order', function() {
        const $section = $(this).closest('.filterable-card-grid-section');
        resetAndSearchFcg($section);
    });

    // PREVENT ENTER FORM SUBMIT
    $(document).on('submit', '.filterable-card-grid-section:not(.case-study-listing-grid-section) form.fcg-filter-form', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.filterable-card-grid-section');
        resetAndSearchFcg($section);
    });

    // LOAD MORE
    $(document).on('click', '.filterable-card-grid-section:not(.case-study-listing-grid-section) .load-more-filterable-card .btn', function(e) {
        e.preventDefault();
        if (isLoading) { return; }

        const $section = $(this).closest('.filterable-card-grid-section');

        let pager = parseInt($section.find('#pager').val()) || 1;
        const max_pages = parseInt($section.find('#max_pages').val()) || 1;

        if (pager >= max_pages) { return; }

        pager++;
        $section.find('#pager').val(pager);

        loadPosts($section, pager);
    });

    // SEARCH BUTTON
    $(document).on('click', '.filterable-card-grid-section:not(.case-study-listing-grid-section) #searchBtn', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.filterable-card-grid-section');
        resetAndSearchFcg($section);
    });

    // ENTER KEY SEARCH
    $(document).on('keypress', '.filterable-card-grid-section:not(.case-study-listing-grid-section) #fcgearch', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            const $section = $(this).closest('.filterable-card-grid-section');
            resetAndSearchFcg($section);
        }
    });

    // URL UPDATE
    function modifyFcgFilterUrl(search_text, industry, use_cases, sort_value) {
        let query_string = '';

        if (search_text) {
            query_string += (query_string ? '&' : '') + 'search_text=' + encodeURIComponent(search_text);
        }

        if (industry) {
            query_string += (query_string ? '&' : '') + 'industry=' + encodeURIComponent(industry);
        }

        if (use_cases) {
            query_string += (query_string ? '&' : '') + 'use_cases=' + encodeURIComponent(use_cases);
        }

        if (sort_value) {
            query_string += (query_string ? '&' : '') + 'filter_order=' + encodeURIComponent(sort_value);
        }

        const newUrl = window.location.pathname + (query_string ? '?' + query_string : '');
        history.pushState(null, null, newUrl);
    }

    // MAIN AJAX
    function loadPosts($section, pager) {
        isLoading = true;

        const industry = $section.find('input[name="industry"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        const use_cases = $section.find('input[name="use_cases"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        const search_text = $section.find('#fcgearch').val() || '';
        const sort_value = $section.find('.filter-order').val() || '';

        if (pager === 1) {
            modifyFcgFilterUrl(search_text, industry, use_cases, sort_value);
        }

        $.ajax({
            url: typeof filter_obj !== 'undefined' ? filter_obj.ajax_url : '/wp-admin/admin-ajax.php',
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_filterable_card',
                pager: pager,
                posts_per_page: $section.find('#posts_per_page').val(),
                search_text: search_text,
                fc_ids: $section.find('#fc_ids').val(),
                industry: industry,
                use_cases: use_cases,
                fcg_industry_select: $section.find('#fcg_industry_select').val(),
                fcg_use_cases_select: $section.find('#fcg_use_cases_select').val(),
                sort_value: sort_value,
            },
            beforeSend: function() {
                $section.find('.filter-load-more').show();
                $section.find('.load-more-filterable-card').hide();
                $section.find('.no-more-result').hide();
            },
            success: function(res) {
                $section.find('.filter-load-more').hide();

                if (pager === 1) {
                    $section.find('.fcg-row').html(res.html);
                } else {
                    $section.find('.fcg-row').append(res.html);
                }

                if (res.max_pages) {
                    $section.find('#max_pages').val(res.max_pages);
                }

                if (!res.html || res.html.trim() === '') {
                    $section.find('.no-more-result').show();
                } else {
                    $section.find('.no-more-result').hide();
                }

                if (res.showing) {
                    $section.find('.showing-result').text(res.showing);
                }

                if (res.next === 1) {
                    $section.find('.load-more-filterable-card').show();
                } else {
                    $section.find('.load-more-filterable-card').hide();
                }
            },
            error: function() {
                $section.find('.filter-load-more').hide();
                $section.find('.no-more-result').show();
            },
            complete: function() {
                isLoading = false;
            },
        });
    }

    /************* Case Study Listing Grid - START *****************/
    function updateCslg($section, page) {
        if (!page) {
            page = 1;
        }
        $section.data('cslg-page', page);

        const $row = $section.find('.cslg-row');
        const $allCols = $row.children('.cslg-col');
        if (!$allCols.length) {
            return;
        }

        const searchText = ($section.find('.cslg-search-input, input[name="search_text"]').val() || '').trim().toLowerCase();
        const sortValue = ($section.find('.cslg-filter-order, .filter-order, select[name="filter_order"]').val() || '').trim();
        const postsPerPage = parseInt($section.attr('data-posts-per-page') || $section.data('posts-per-page'), 10) || 8;

        const matching = [];
        const nonMatching = [];

        $allCols.each(function() {
            const el = this;
            const $el = $(el);
            const title = ($el.attr('data-title') || $el.find('.fcg-card-title').text() || '').trim().toLowerCase();
            const desc = ($el.attr('data-desc') || $el.find('.fcg-card-content p').text() || '').trim().toLowerCase();

            let isMatch = true;
            if (searchText && title.indexOf(searchText) === -1 && desc.indexOf(searchText) === -1) {
                isMatch = false;
            }

            if (isMatch) {
                matching.push(el);
            } else {
                nonMatching.push(el);
            }
        });

        matching.sort(function(a, b) {
            const $a = $(a);
            const $b = $(b);
            const titleA = ($a.attr('data-title') || $a.find('.fcg-card-title').text() || '').trim().toLowerCase();
            const titleB = ($b.attr('data-title') || $b.find('.fcg-card-title').text() || '').trim().toLowerCase();
            const idxA = parseInt($a.attr('data-index'), 10) || 0;
            const idxB = parseInt($b.attr('data-index'), 10) || 0;

            if (sortValue === 'ASC') {
                return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
            } else if (sortValue === 'DESC') {
                return titleB.localeCompare(titleA, undefined, { numeric: true, sensitivity: 'base' });
            } else if (sortValue === 'oldest') {
                return idxB - idxA;
            } else {
                // Default "Most Recent": original index order
                return idxA - idxB;
            }
        });

        for (let i = 0; i < matching.length; i++) {
            $row.append(matching[i]);
        }
        for (let j = 0; j < nonMatching.length; j++) {
            $row.append(nonMatching[j]);
            $(nonMatching[j]).css('display', 'none');
        }

        const totalMatching = matching.length;
        const visibleLimit = postsPerPage > 0 ? page * postsPerPage : totalMatching;

        for (let k = 0; k < matching.length; k++) {
            if (k < visibleLimit) {
                $(matching[k]).css('display', '');
            } else {
                $(matching[k]).css('display', 'none');
            }
        }

        const $showing = $section.find('.cslg-showing-result, .showing-result');
        const $noResults = $section.find('.cslg-no-results, .no-more-result');
        const $loadMore = $section.find('.cslg-load-more, .load-more-filterable-card');

        if (totalMatching === 0) {
            $showing.text('Showing 0');
            $noResults.show();
            $loadMore.hide();
        } else {
            $noResults.hide();
            const end = Math.min(visibleLimit, totalMatching);
            $showing.text('Showing 1-' + end + ' of ' + totalMatching);

            if (postsPerPage > 0 && end < totalMatching) {
                $loadMore.show();
            } else {
                $loadMore.hide();
            }
        }
    }

    // Search input
    $(document).on('input', '.case-study-listing-grid-section .cslg-search-input, .case-study-listing-grid-section input[name="search_text"]', function() {
        const $section = $(this).closest('.case-study-listing-grid-section');
        updateCslg($section, 1);
    });

    // Search button
    $(document).on('click', '.case-study-listing-grid-section .cslg-search-btn, .case-study-listing-grid-section .icon-search', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.case-study-listing-grid-section');
        updateCslg($section, 1);
    });

    // Enter key
    $(document).on('keypress', '.case-study-listing-grid-section .cslg-search-input, .case-study-listing-grid-section input[name="search_text"]', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            const $section = $(this).closest('.case-study-listing-grid-section');
            updateCslg($section, 1);
        }
    });

    // Sort order change
    $(document).on('change', '.case-study-listing-grid-section select.filter-order, .case-study-listing-grid-section .cslg-filter-order, .case-study-listing-grid-section select[name="filter_order"]', function() {
        const $section = $(this).closest('.case-study-listing-grid-section');
        updateCslg($section, 1);
    });

    // Reset filter
    $(document).on('click', '.case-study-listing-grid-section .reset-filter, .case-study-listing-grid-section .filter-reset a, .case-study-listing-grid-section .cslg-reset-filter', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.case-study-listing-grid-section');
        $section.find('.cslg-search-input, input[name="search_text"]').val('');
        $section.find('select.filter-order, .cslg-filter-order, select[name="filter_order"]').val('').prop('selectedIndex', 0);
        $section.find('input[type="checkbox"]').prop('checked', false);
        $section.find('.lg-filter-selected-list').empty();
        updateCslg($section, 1);
    });

    // Load more click
    $(document).on('click', '.case-study-listing-grid-section .cslg-load-more .btn, .case-study-listing-grid-section .load-more-filterable-card .btn', function(e) {
        e.preventDefault();
        const $section = $(this).closest('.case-study-listing-grid-section');
        let page = parseInt($section.data('cslg-page'), 10) || 1;
        page++;
        updateCslg($section, page);
    });

    // Prevent form submit
    $(document).on('submit', '.case-study-listing-grid-section form', function(e) {
        e.preventDefault();
    });

    // Initialize all Case Study grids on load
    $('.case-study-listing-grid-section').each(function() {
        updateCslg($(this), 1);
    });
    /************* Case Study Listing Grid - END *****************/
});

